import React, { ReactNode } from 'react';
import styled from 'styled-components';

const TableSt = {
  Wrap: styled.div<{ $maxHeight?: number; $minWidth?: number }>`
    width: 100%;
    ${(p) => p.$minWidth && 'min-width:' + p.$minWidth + 'px'};
    ${(p) => p.$maxHeight && 'max-height:' + p.$maxHeight + 'px'}
  `,
  Table: styled.table<{ type: string }>`
    table-layout: fixed;
    position: relative;
    border-collapse: separate;
    width: 100%;
    ${(p) =>
      p.type === 'row'
        ? `tr {
      
      th {
        height: 40px;
        box-sizing: border-box;
        background: #e2f1f7;
        border-left: 1px solid #cbdae7;
        border-bottom: 1px solid #cbdae7;
      }
      td{
        border-left: 1px solid #cbdae7;
        &:not(:last-child){border-right:0;}
      }
      
      &:first-child {
        th{
          border-top:1px solid #cbdae7;
          &:first-child {
            border-top-left-radius: 12px;
          }
          &:last-child {
            border-top-right-radius:12px;
          }
        }
      }
      &:last-child {
        th{
          &:first-child {
            border-bottom-left-radius: 12px;
          }
          &:last-child {
            border-bottom-right-radius: 12px;
          }
        }
      }
      
    }`
        : ''}
  `,
  Thead: styled.thead<{ type: string }>`
    position: sticky;
    z-index: 2;
    top: 0;
    ${(p) =>
      p.type === 'col' &&
      `
      
    tr {
      th {
        height: 40px;
        box-sizing: border-box;
        background: #e2f1f7;
      
        border-bottom: 1px solid #cbdae7;
        border-right: 1px solid #cbdae7;
        &:first-child {
          border-left: 1px solid #cbdae7;
        }
      }
      &:first-child {
        th {
          border-top: 1px solid #cbdae7;

          &:first-child {
            border-radius: 12px 0 0 0;
          }

          &:last-child {
            border-radius: 0 12px 0 0;
          }
        }
      }
    }
      `}
  `,
  Tbody: styled.tbody<{ type: string; $cellHeight?: number }>`
    tr {
      td {
        height: ${(p) => (p.$cellHeight ? p.$cellHeight + 'px' : '40px')};
        box-sizing: border-box;
        background: #fff;
        text-align: center;
        border-right: 1px solid #cbdae7;
        &:first-child {
          border-left: 1px solid #cbdae7;
        }
      }
      &:first-child {
        ${(p) =>
          p.type === 'row' &&
          `
            td {
              border-top: 1px solid #cbdae7;
              &:first-child {
                border-top-left-radius: 12px;
              }
              &:last-child {
                border-top-right-radius: 12px;
              }
            }`}
      }
      &:last-child {
        td {
          border-bottom: 1px solid #cbdae7;

          &:first-child {
            border-bottom-left-radius: 12px;
          }

          &:last-child {
            border-bottom-right-radius: 12px;
          }
        }
      }
      &:not(:last-child) {
        td {
          border-bottom: 1px solid #cbdae7;
        }
      }
    }
  `,
};

interface TableProps {
  caption: string;
  colgroup: (string | number)[];
  thead?: ReactNode;
  tbody: ReactNode;
  type?: string;
  $cellHeight?: number;
  $maxHeight?: number;
  $minWidth?: number;
}

const Table = ({ caption, colgroup, thead, tbody, type = 'col', $cellHeight, $maxHeight, $minWidth }: TableProps) => {
  return (
    <TableSt.Wrap className={'cScroll'} $maxHeight={$maxHeight} $minWidth={$minWidth}>
      <TableSt.Table type={type}>
        <caption>{caption}</caption>
        <colgroup>
          {colgroup.map((i, index) => {
            return <col key={index} style={{ width: i }} />;
          })}
        </colgroup>
        {type === 'col' && <TableSt.Thead type={type}>{thead}</TableSt.Thead>}
        <TableSt.Tbody type={type} $cellHeight={$cellHeight}>
          {tbody}
        </TableSt.Tbody>
      </TableSt.Table>
    </TableSt.Wrap>
  );
};

export default Table;
